import { Injectable } from "@angular/core";
import { HttpClient } from "../../shared/wrappers/HttpClient";
import { BillingLetter } from "../../models/billing-letter/BillingLetter.model";
import { Parcel } from "../../models/billing-letter/Parcel.model";

@Injectable()
export class BillingLetterService {
    constructor(private httpClient: HttpClient) { }

    endPoint: String = "/billing-letters";

    async create(billingLetter: BillingLetter) {
        const res = await this.httpClient.post(this.endPoint, billingLetter);
        return res;
    }

    async getAll(queryString) {
        return await this.httpClient.get(`${this.endPoint}?${queryString}`);
    }

    async getAllOld(queryString) {
        return await this.httpClient.get(`/old-billings?${queryString}`);
    }

    async findOne(id) {
        return await this.httpClient.get(`${this.endPoint}/${id}`);
    }

    async update(billingLetter: BillingLetter, id) {
        const res = await this.httpClient.update(this.endPoint, id, billingLetter)
        return res;
    }

    async getSapDocNumber(sapDocEntry: string) {
        return await this.httpClient.get(`${this.endPoint}/sap/${sapDocEntry}`);
    }

    async cancelOrderSap(parcelRemoved: Parcel) {
        return await this.httpClient.update(`${this.endPoint}/sap`, parcelRemoved.sapDocEntry, parcelRemoved);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/billing-letter/billing-letter.service.ts